import { Button, Col, Modal, Row, Table, InputNumber, DatePicker, Pagination, Space } from 'antd'
import { useEffect, useState } from 'react'
import { observer } from 'mobx-react-lite'
import {
   DATE_FORMAT_CLIENT,
   DATE_FORMAT_CLIENT_PARAMS,
   DATE_TIME_FORMAT_CLIENT_short,
   PAGE_SIZE,
   ROLES,
   getPage,
   getUniqueCodeBank,
   typeFund
} from 'src/helpers/constants'
import { useStore } from 'src/hooks'
import { CloseCircleOutlined, DownloadOutlined, ExclamationCircleOutlined } from '@ant-design/icons'
import { GLOBAL_CLIENT } from 'src/helpers/GlobalClient'
import { useTranslation } from 'react-i18next'
import moment from 'moment'
import 'moment/locale/vi'
import locale from 'antd/es/date-picker/locale/vi_VN'
import { debounce, isEmpty } from 'lodash'
import { formatCurrency, showMessageSuccess } from 'src/helpers/functions'
import theme from 'src/helpers/theme'
import styled from 'styled-components'
import useModal from 'src/helpers/modal/useModal'
import CreateOrder from '../order/Create'
import useTableScrollY from 'src/common/useTableScrollY'
// @ts-ignore
import ReactExport from 'react-data-export'

const ExcelFile = ReactExport.ExcelFile
const ExcelSheet = ReactExport.ExcelFile.ExcelSheet
const ExcelColumn = ReactExport.ExcelFile.ExcelColumn

const PENDING_TRANSACTION_STATUS = 'pending'

const isPendingTransaction = (record: any) =>
   record?.status === PENDING_TRANSACTION_STATUS || record?.statusText === PENDING_TRANSACTION_STATUS

const getTransactionRows = (data: any) => {
   if (Array.isArray(data)) return data
   if (Array.isArray(data?.rows)) return data.rows
   if (Array.isArray(data?.data)) return data.data
   return []
}
// interface Transaction {
//    jobId: number
//    time: Date
//    type: string
//    quantity: number
//    unitPrice: number
//    amount: number
//    remainingBudget: number
// }
const TransactionHistory = observer(({ visible, handleCancel, account, role }: any) => {
   const isModalMode = visible !== undefined
   const isVisible = isModalMode ? visible : true
   const AuthStore = useStore('AuthStore')
   const currentRole = role || AuthStore.data_role
   const FundStore = useStore('FundStore')
   const OrdersStore = useStore('OrdersStore')
   const CommonConfigStore = useStore('CommonConfigStore')
   const [showWithdrawModal, setShowWithdrawModal] = useState(false)
   const [isUSD, setUSD] = useState<any>(true)
   const [selectedItem, setSelectedItem] = useState<any>([])
   const [visibleDetail, setVisibleDetail] = useState(false)
   const minRutTienConfig = CommonConfigStore?.designerConfigList?.minWithdraw || 0
   const minTienGiuLaiConfig = CommonConfigStore?.designerConfigList?.amountHold || 0
   const mintienDuocRut = parseInt(minRutTienConfig) + parseInt(minTienGiuLaiConfig)
   const mintienCoTheRut = (
      parseFloat(AuthStore?.data_getUserInfo?.wallet?.balance) - parseFloat(minTienGiuLaiConfig)
   ).toFixed(2)

   console.log(
      'minTienGiuLaiConfig: ',
      minTienGiuLaiConfig,
      'minRutTienConfig',
      minRutTienConfig,
      'mintienDuocRut',
      mintienDuocRut,
      'mintienCoTheRut',
      mintienCoTheRut,
      'withdrawAmount'
   )

   const [withdrawAmount, setWithdrawAmount] = useState<any>(AuthStore?.data_getUserInfo?.wallet?.balance)
   const [withdrawError, setWithdrawError] = useState('')
   const [withdrawWarning, setWithdrawWarning] = useState('')
   const [startTime, setStartTime] = useState(moment().subtract(1, 'months'))
   const [endTime, setEndTime] = useState(moment())
   const { rows, count, offset } = AuthStore.transactionHistory
   const progressRows = getTransactionRows(AuthStore.transactionProgress).map((item: any) => ({
      ...item,
      status: item?.status || PENDING_TRANSACTION_STATUS,
      statusText: item?.statusText || PENDING_TRANSACTION_STATUS
   }))
   const historyRows = (rows || []).filter((item: any) => !isPendingTransaction(item))
   const hasProgressTransactions = progressRows.length > 0
   const {
      paginationRef,
      scrollY: historyTableScrollY,
      tableWrapperRef: historyTableWrapperRef
   } = useTableScrollY({
      enabled: isVisible,
      dependencyKey: `${historyRows.length}-${count}-${hasProgressTransactions}-${progressRows.length}`
   })
   const [remainingBudget, setRemainingBudget] = useState<number>(AuthStore?.data_getUserInfo?.wallet?.balance)
   const { t } = useTranslation()
   const { confirm } = useModal()
   // const [withdrawSuccess, setWithdrawSuccess] = useState('')
   useEffect(() => {
      if (isVisible) {
         getListData(0, {
            // text: textSearch,
            from: moment(startTime).format(DATE_FORMAT_CLIENT_PARAMS).toString(),
            to: moment(endTime).format(DATE_FORMAT_CLIENT_PARAMS).toString()
         })
      }
      // eslint-disable-next-line react-hooks/exhaustive-deps
   }, [startTime, endTime, isVisible])

   useEffect(() => {
      if (parseInt(AuthStore?.data_getUserInfo?.wallet?.balance) < mintienDuocRut) {
         setWithdrawError(t(GLOBAL_CLIENT.dudieukienruttien).replace('{0}', formatCurrency(mintienDuocRut)))
      } else {
         setWithdrawAmount(mintienCoTheRut)
      }
      // eslint-disable-next-line react-hooks/exhaustive-deps
   }, [showWithdrawModal, mintienDuocRut, AuthStore?.data_getUserInfo?.wallet?.balance])

   const getListData = async (currentPage: number, param?: any) => {
      try {
         // setIsLoading(true)
         const offset = getPage(currentPage)
         let params = { offset, ...param }
         if (account) {
            params.accountId = account?.id
            await AuthStore.getTransaction(params)
            AuthStore.resetTransactionProgress()
         } else {
            await Promise.all([AuthStore.getTransaction(params), AuthStore.getTransactionProgress()])
         }
         // await FundStore.getFundList(params)
      } catch (error) {
         // console.log(error)
      } finally {
         // setIsLoading(false)
      }
   }

   const onChange = (currentPage: number) => {
      getListData(currentPage - 1, {
         ...{
            from: moment(startTime).format(DATE_FORMAT_CLIENT_PARAMS).toString(),
            to: moment(endTime).format(DATE_FORMAT_CLIENT_PARAMS).toString()
         }
      })
   }
   const onChangeStatus = (e: any) => {
      // const val = e.target.checked ? 1 : 0
      // console.log('val; ', val, 'e: ', e.target.checked)
      setUSD(e.target.checked)
   }
   const handleWithdraw = async () => {
      // const now = moment()
      // const weekAgo = moment().subtract(7, 'days')
      confirm({
         title: t(GLOBAL_CLIENT.xacnhanck),
         icon: <ExclamationCircleOutlined />,
         content: `<div>
            <div>
               ${t(GLOBAL_CLIENT.bankName)}: ${AuthStore?.data_getUserInfo?.bankName}
            </div>
            <div>
               ${t(GLOBAL_CLIENT.accountBankName)}: ${AuthStore?.data_getUserInfo?.accountBankName}
            </div>
            <div>
               ${t(GLOBAL_CLIENT.bankAccount)}: ${AuthStore?.data_getUserInfo?.bankNumber}
            </div>
         </div>`,
         onCancel() {},
         okText: t(GLOBAL_CLIENT.dongy),
         cancelText: t(GLOBAL_CLIENT.huy),
         async onOk() {
            const params = {
               price: withdrawAmount || '',
               priceVND:
                  parseFloat(withdrawAmount + '') * parseFloat(CommonConfigStore?.designerConfigList?.exchangeRate),
               code: getUniqueCodeBank(),
               // account: AuthStore?.data_getUserInfo?.id || '',
               description: t(GLOBAL_CLIENT.fullfilmentruttien),
               type: typeFund.WITHDRAW
               // status:1
            }

            // console.log('params ', params, 'AuthStore?.data_getUserInfo;', AuthStore?.data_getUserInfo)
            const response = await FundStore.createFund(params)
            if (response?.code === 200) {
               showMessageSuccess(t(GLOBAL_CLIENT.hethongdangxacnhan1den10))
            }

            setWithdrawAmount(0)
            setWithdrawError('')
            setShowWithdrawModal(false)
            handleCancel && handleCancel()
         }
      })

      // console.log('withdrawAmount', withdrawAmount)
   }

   let columns = [
      {
         title: 'OrderId',
         dataIndex: 'order',
         // sorter: (a: any, b: any) => a.jobId - b.jobId,
         key: 'order',
         render: (value: any, record: any) => {
            const orderCode = value?.code || record?.orderCode || record?.code
            return (
               <span
                  onClick={() => showDetailOrder(record)}
                  style={{ textDecoration: 'underline' }}
                  className="gx-link txtMax2Line"
               >
                  {orderCode ?? '-'}
               </span>
            )
         }
      },
      {
         title: t(GLOBAL_CLIENT.thoigian),
         dataIndex: 'createdAt',
         // sorter: (a: any, b: any) => a.time - b.time,
         key: 'createdAt',
         render: (time: Date) => moment(time).format(DATE_TIME_FORMAT_CLIENT_short)
      },
      {
         title: t(GLOBAL_CLIENT.loaigiaodich),
         dataIndex: 'description',
         // sorter: (a: any, b: any) => a.type - b.type,
         key: 'description',
         render: (value: any) => {
            return <span className="txtMax2Line">{value}</span>
            // return <span className="txtMax2Line">{getTypeThuChi(value)}</span>
         }
      },
      {
         title: 'Trạng thái',
         dataIndex: 'status',
         key: 'status',
         width: 140,
         render: (_: any, record: any) => {
            if (isPendingTransaction(record)) {
               return <span className="transaction-status-pending">Chờ Xác nhận</span>
            }

            return <span className="txtMax2Line">Hoàn thành</span>
         }
      },
      {
         title: currentRole === ROLES.SELLER ? t(GLOBAL_CLIENT.tongcong) : t(GLOBAL_CLIENT.money),
         dataIndex: 'price',
         key: 'price',
         render: (value: any, record: any) => {
            return (
               <span className="txtMax2Line" style={{ color: record?.type ? 'green' : 'red' }}>
                  {record?.type ? '+ ' : '- '}
                  {/* {role = ROLES.ADMIN ? (
                     <span>
                        {formatCurrency(record?.priceVND, true)}đ |{formatCurrency(record?.price)}$
                     </span>
                  ) : ( */}
                  {currentRole === ROLES.NCC ? (
                     <span>{formatCurrency(record?.priceVND, true)}đ</span>
                  ) : (
                     <span>${formatCurrency(record?.price)}</span>
                  )}
                  {/* )} */}
               </span>
            )
         }
         // sorter: (a: any, b: any) => a.amount - b.amount,
         // render: (amount: number) =>
         //    new Intl.NumberFormat('vi-VN', { style: 'currency', currency: 'VND' }).format(amount)
      },
      {
         title: currentRole === ROLES.SELLER ? t(GLOBAL_CLIENT.ngansachconlai) : t(GLOBAL_CLIENT.tongcong),
         dataIndex: 'balance',
         // sorter: (a: any, b: any) => a.remainingBudget - b.remainingBudget,
         key: 'balance',
         render: (value: any, record: any) => {
            return (
               <span className="txtMax2Line">
                  {/* {role === ROLES.ADMIN ? (
                     <span>
                        {formatCurrency(record?.balanceVND, true)}đ |{formatCurrency(record?.balance)}$
                     </span>
                  ) : ( */}
                  {currentRole === ROLES.NCC ? (
                     <span>{formatCurrency(record?.balanceVND, true)}đ</span>
                  ) : (
                     <span>${formatCurrency(record?.balance)}</span>
                  )}
                  {/* )} */}
               </span>
            )
         }
         // render: (remainingBudget: number) =>
         //    new Intl.NumberFormat('vi-VN', { style: 'currency', currency: 'VND' }).format(remainingBudget)
      }
   ]

   const handleRangePickerChange = (date: any) => {
      // set_dateRangerPicker(date);
      // console.log('datee: ', date)
      setStartTime(date[0])
      setEndTime(date[1])
   }
   const renderPagination = () => {
      if (isEmpty(rows)) {
         return null
      }

      return (
         <div className="containerPagination" ref={paginationRef}>
            <Pagination
               onChange={onChange}
               pageSize={PAGE_SIZE}
               current={offset / PAGE_SIZE + 1}
               showSizeChanger={false}
               total={count}
            />
         </div>
      )
   }
   const formatDataProducts = (list: any) => {
      return list.map((item: any) => {
         return {
            name: item.product.name,
            id: item.product.id,
            images: item.product.images,
            base_cost: item.baseCostSellter,
            qty: item.qty,
            tags: item.product.tags
         }
      })
   }
   const showDetailOrder = async (item: any) => {
      if (item?.order?.id) {
         try {
            const result = await OrdersStore.getDetail(item?.order?.id)
            setSelectedItem(result?.order)
            const listProduct = formatDataProducts(result?.listProductInOrder)
            OrdersStore.setProductsSelected(listProduct)
            setVisibleDetail(true)
         } catch (error) {
            console.error(error)
         }
      }
   }
   const StyledRangePickerContainer = styled.div`
      @media (max-width: 576px) {
         .ant-picker-panels {
            flex-direction: column !important;
         }
      }
   `
   const getExportData = (list: any[]) =>
      list.map((item: any) => ({
         ...item,
         orderCode: item?.order?.code || item?.orderCode || item?.code || '-',
         createdAtText: item?.createdAt ? moment(item.createdAt).format(DATE_TIME_FORMAT_CLIENT_short) : '',
         priceText: currentRole === ROLES.NCC ? item?.priceVND || 0 : item?.price || 0,
         balanceText: currentRole === ROLES.NCC ? item?.balanceVND || 0 : item?.balance || 0,
         transactionType: item?.type ? 'Thu' : 'Chi',
         statusLabel: isPendingTransaction(item) ? 'Chờ Xác nhận' : 'Hoàn thành'
      }))
   const progressExportData = getExportData(progressRows)
   const historyExportData = getExportData(historyRows)

   const renderExportButton = (filename: string, sheetName: string, data: any[]) => (
      <ExcelFile
         element={
            <Button size="small">
               {t(GLOBAL_CLIENT.exportExcel)}
               <DownloadOutlined />
            </Button>
         }
         filename={`${filename}-${moment().format('YYYYMMDD-HHmmss')}`}
      >
         <ExcelSheet data={data} name={sheetName}>
            <ExcelColumn label={'OrderId'} value="orderCode" />
            <ExcelColumn label={t(GLOBAL_CLIENT.thoigian)} value="createdAtText" />
            <ExcelColumn label={t(GLOBAL_CLIENT.loaigiaodich)} value="description" />
            <ExcelColumn label={'Loại'} value="transactionType" />
            <ExcelColumn label={'Trạng thái'} value="statusLabel" />
            <ExcelColumn
               label={currentRole === ROLES.SELLER ? t(GLOBAL_CLIENT.tongcong) : t(GLOBAL_CLIENT.money)}
               value="priceText"
            />
            <ExcelColumn
               label={currentRole === ROLES.SELLER ? t(GLOBAL_CLIENT.ngansachconlai) : t(GLOBAL_CLIENT.tongcong)}
               value="balanceText"
            />
         </ExcelSheet>
      </ExcelFile>
   )

   const renderTableTitle = (title: string, total: number, exportButton: any) => (
      <div className="transaction-table-title">
         <div className="transaction-section-title">
            {title} <span className="transaction-section-count">({total} bản ghi)</span>
         </div>
         {exportButton}
      </div>
   )

   const renderContent = () => (
      <>
         <style>{`
            .transaction-row-pending td {
               background: #fff7e6 !important;
            }

            .transaction-row-pending td:first-child {
               border-left: 3px solid #fa8c16;
            }

            .transaction-status-pending {
               color: #d46b08;
               background: #fff7e6;
               border: 1px solid #ffd591;
               border-radius: 4px;
               padding: 2px 4px;
               white-space: nowrap;
               font-size: 11px;
            }

            .transaction-progress-section {
               margin: 12px 0 16px;
            }

            .transaction-table-title {
               display: flex;
               align-items: center;
               justify-content: space-between;
               gap: 12px;
            }

            .transaction-section-title {
               display: flex;
               align-items: center;
               gap: 8px;
               margin: 0;
               padding: 0;
               font-size: 14px;
               font-weight: 600;
               color: #262626;
            }

            .transaction-section-count {
               color: #595959;
               font-size: 12px;
               font-weight: 400;
            }

            .transaction-history-table .ant-table-body {
               min-height: ${historyTableScrollY}px;
            }
         `}</style>
         {AuthStore.data_role === ROLES.FULFILLMENT && (
            <Row
               gutter={[16, 16]}
               className="gx-flex-row gx-align-items-center gx-justify-content-start gx-mb-2"
               wrap={false}
            >
               <Col>
                  <div style={{ paddingTop: 10, paddingBottom: 10, borderRadius: 4 }}>
                     <div
                        style={{
                           fontSize: '16px',
                           lineHeight: '24px',
                           fontWeight: 600,
                           color: '#FFAD63'
                        }}
                        className="gx-fs-md gx-text-center"
                     >
                        ${formatCurrency(remainingBudget)}
                     </div>
                  </div>
               </Col>
               {currentRole === ROLES.FULFILLMENT && (
                  <Col>
                     <div
                        style={{
                           fontSize: '14px',
                           lineHeight: '22px',
                           fontWeight: 400,
                           backgroundColor: '#272944',
                           color: '#fff',
                           padding: '9px 16px',
                           borderRadius: 8,
                           cursor: 'pointer'
                        }}
                        onClick={() => setShowWithdrawModal(true)}
                     >
                        {t(GLOBAL_CLIENT.withdawal)}
                     </div>
                  </Col>
               )}
               <Col></Col>
            </Row>
         )}
         <Row style={{ alignItems: 'center', justifyContent: 'flex-end', paddingLeft: 12, paddingRight: 12 }}>
            <Space className="total-items">
               <ExcelFile
                  element={
                     <Button>
                        {t(GLOBAL_CLIENT.exportExcel)}
                        <DownloadOutlined />
                     </Button>
                  }
                  filename={`transactions-${moment().format('YYYYMMDD-HHmmss')}`}
               >
                  <ExcelSheet data={progressExportData} name="TransactionProgress">
                     <ExcelColumn label={'OrderId'} value="orderCode" />
                     <ExcelColumn label={t(GLOBAL_CLIENT.thoigian)} value="createdAtText" />
                     <ExcelColumn label={t(GLOBAL_CLIENT.loaigiaodich)} value="description" />
                     <ExcelColumn label={'Loại'} value="transactionType" />
                     <ExcelColumn label={'Trạng thái'} value="statusLabel" />
                     <ExcelColumn
                        label={currentRole === ROLES.SELLER ? t(GLOBAL_CLIENT.tongcong) : t(GLOBAL_CLIENT.money)}
                        value="priceText"
                     />
                     <ExcelColumn
                        label={
                           currentRole === ROLES.SELLER ? t(GLOBAL_CLIENT.ngansachconlai) : t(GLOBAL_CLIENT.tongcong)
                        }
                        value="balanceText"
                     />
                  </ExcelSheet>
                  <ExcelSheet data={historyExportData} name="TransactionHistory">
                     <ExcelColumn label={'OrderId'} value="orderCode" />
                     <ExcelColumn label={t(GLOBAL_CLIENT.thoigian)} value="createdAtText" />
                     <ExcelColumn label={t(GLOBAL_CLIENT.loaigiaodich)} value="description" />
                     <ExcelColumn label={'Loại'} value="transactionType" />
                     <ExcelColumn label={'Trạng thái'} value="statusLabel" />
                     <ExcelColumn
                        label={currentRole === ROLES.SELLER ? t(GLOBAL_CLIENT.tongcong) : t(GLOBAL_CLIENT.money)}
                        value="priceText"
                     />
                     <ExcelColumn
                        label={
                           currentRole === ROLES.SELLER ? t(GLOBAL_CLIENT.ngansachconlai) : t(GLOBAL_CLIENT.tongcong)
                        }
                        value="balanceText"
                     />
                  </ExcelSheet>
               </ExcelFile>
               <DatePicker.RangePicker
                  allowClear={false}
                  defaultValue={[startTime, endTime]}
                  format={DATE_FORMAT_CLIENT}
                  locale={locale}
                  onChange={handleRangePickerChange}
                  panelRender={(panelNode) => <StyledRangePickerContainer>{panelNode}</StyledRangePickerContainer>}
               />
            </Space>
         </Row>

         {hasProgressTransactions && (
            <div className="transaction-progress-section">
               <Table
                  scroll={{ x: 800 }}
                  tableLayout="fixed"
                  columns={columns}
                  dataSource={progressRows}
                  title={() =>
                     renderTableTitle(
                        'Giao dịch đang xử lý',
                        progressRows.length,
                        renderExportButton('transaction-progress', 'TransactionProgress', progressExportData)
                     )
                  }
                  rowKey={(record: any, index?: number) =>
                     record?.id || record?.walletTransactionId || `transaction-progress-${index}`
                  }
                  rowClassName={() => 'transaction-row-pending'}
                  pagination={false}
               />
            </div>
         )}

         <div ref={historyTableWrapperRef}>
            <Table
               className="transaction-history-table"
               scroll={{ x: 800, y: historyTableScrollY }}
               tableLayout="fixed"
               columns={columns}
               dataSource={historyRows}
               title={() =>
                  renderTableTitle(
                     'Lịch sử giao dịch',
                     count,
                     renderExportButton('transaction-history', 'TransactionHistory', historyExportData)
                  )
               }
               rowKey={(record: any, index?: number) =>
                  record?.id || record?.walletTransactionId || `transaction-${index}`
               }
               pagination={false}
            />
         </div>

         {renderPagination()}
         {showWithdrawModal && currentRole == ROLES.FULFILLMENT && (
            <Modal
               title={t(GLOBAL_CLIENT.withdawal)}
               visible={showWithdrawModal}
               onOk={handleWithdraw}
               onCancel={() => {
                  setShowWithdrawModal(false)
                  setWithdrawAmount(0)
                  setWithdrawError('')
               }}
               closable={true}
               closeIcon={<CloseCircleOutlined />}
               footer={null}
            >
               <InputNumber
                  disabled
                  defaultValue={withdrawAmount}
                  formatter={(value) =>
                     `${parseFloat(value as string).toFixed(2)}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
                  }
                  parser={(value) => value!.replace(/\$\s?|(,*)/g, '')}
                  placeholder={t(GLOBAL_CLIENT.inputPrice)}
                  onChange={(value) => setWithdrawAmount(value)}
                  style={{ marginBottom: '10px' }}
                  step={1000}
                  // max={MinMaxRutTien.max}
                  // min={MinMaxRutTien.min}
               />
               {/* <Checkbox name="USD" defaultChecked={isUSD} onChange={onChangeStatus} disabled>
                  <label>CK tiền USD</label>
               </Checkbox> */}
               {!isUSD && (
                  <div>
                     Quy đổi USD:
                     {withdrawAmount
                        ? ' ' +
                          '$' +
                          formatCurrency(
                             parseFloat(withdrawAmount + '') / CommonConfigStore?.designerConfigList?.exchangeRate
                          )
                        : 0}
                  </div>
               )}
               {isUSD && (
                  <div>
                     Quy đổi VND:
                     {withdrawAmount
                        ? ' ' +
                          formatCurrency(
                             parseFloat(withdrawAmount + '') * CommonConfigStore?.designerConfigList?.exchangeRate,
                             true
                          ) +
                          ' đ'
                        : 0}
                  </div>
               )}
               {withdrawError && <p style={{ color: 'red' }}>{withdrawError}</p>}
               {withdrawWarning && <p style={{ color: theme?.color.grey_1 }}>{withdrawWarning}</p>}
               <div className="gx-flex-row gx-justify-content-end">
                  <Button
                     style={{
                        fontSize: '14px',
                        lineHeight: '22px',
                        fontWeight: 400,
                        backgroundColor: '#FFAD63',
                        color: '#fff'
                     }}
                     disabled={withdrawAmount <= 0}
                     onClick={debounce(handleWithdraw, 500)}
                  >
                     {t(GLOBAL_CLIENT.apply)}
                  </Button>
               </div>
            </Modal>
         )}
         {visibleDetail && (
            <CreateOrder
               onlyView
               visible={visibleDetail}
               item={selectedItem}
               // onOk={() => handleOrderCreator(true)}
               // fieldFilter={fieldFilter}
               // textSearch={textSearch}
               onCancel={() => setVisibleDetail(false)}
               // onShowProducts={() => setVisibleProductModal(true)}
               // onRemove={(id: string) => handleRemoveOrder(id)}
            />
         )}
      </>
   )

   if (!isModalMode) {
      return <div>{renderContent()}</div>
   }

   return (
      <Modal
         visible={visible}
         title={t(GLOBAL_CLIENT.transactionHistory)}
         onCancel={handleCancel}
         closable={true}
         closeIcon={<CloseCircleOutlined />}
         width={'90%'}
         style={{ maxWidth: '1000px' }}
         maskClosable={false}
         footer={null}
      >
         {renderContent()}
      </Modal>
   )
})

export default TransactionHistory
